import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbs } from '../../contexts/BreadcrumbContext';
import { useSyncPillState } from '../../hooks/useSyncPillState';
import { SyncPill } from '../patterns';
import OfflineMapStatus from '../OfflineMapStatus';
import './AppShell.css';

export interface TopBarProps {
  /** Open the phone off-canvas drawer. */
  onOpenMobile: () => void;
  /** Toggle the tablet pin-open state. */
  onTogglePin: () => void;
  pinned: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ onOpenMobile, onTogglePin, pinned }) => {
  const { t } = useTranslation();
  const crumbs = useBreadcrumbs();
  const sync = useSyncPillState();

  return (
    <header className="shell-topbar">
      <button
        className="shell-topbar__hamburger"
        onClick={onOpenMobile}
        aria-label={t('shell.openSidebar')}
        type="button"
      >
        <i className="bi bi-list" aria-hidden="true" />
      </button>
      <button
        className="shell-topbar__pin"
        onClick={onTogglePin}
        aria-label={pinned ? t('shell.unpinSidebar') : t('shell.pinSidebar')}
        type="button"
      >
        <i className={`bi bi-${pinned ? 'pin-angle-fill' : 'pin-angle'}`} aria-hidden="true" />
      </button>
      <nav className="shell-topbar__crumbs" aria-label="breadcrumb">
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          const cls = `shell-topbar__crumb${isLast ? ' shell-topbar__crumb--here' : ''}`;
          if (isLast || !c.to) {
            return (
              <span key={i} className={cls}>{c.label}</span>
            );
          }
          return (
            <React.Fragment key={i}>
              <Link to={c.to} className={cls}>{c.label}</Link>
              <span className="shell-topbar__crumb-sep" aria-hidden="true">/</span>
            </React.Fragment>
          );
        })}
      </nav>
      <div className="shell-topbar__right">
        <SyncPill tone={sync.tone} label={sync.label} />
        <OfflineMapStatus />
        <button
          className="shell-topbar__bell"
          type="button"
          aria-label={t('shell.notifications')}
        >
          <i className="bi bi-bell" aria-hidden="true" />
        </button>
      </div>
    </header>
  );
};

export default TopBar;
